export const setAriaLabel = (product) => {
    if (product) {
        return product.price.isOutletPrice || product.price.isMarkedDown
            ? `${product.name}. Original price ${product.price.previous.text}. Sale price ${product.price.current.text}.`
            : `${product.name}. ${product.price.current.text}`;
    }
};
